import React from 'react';
import ReactDOM from 'react-dom/client';

import { IProduct } from './IProduct';
//import mockdata from './mockdata';
import Pdp from './pdp';
//import mockData from './Pdp.mock';

const id = 'product-details-page';
const productDataID = 'productData';
const element = document.getElementById(id);
const productDataElement = document.getElementById(productDataID);
const data = JSON.parse(productDataElement.dataset.value) as IProduct;
const root = ReactDOM.createRoot(element);

if (element) {
    root.render(<Pdp productData={data} />);
}
